<template>
    <div id="contract_type_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="contractTypeHeader" v-if="$route.params.id > 0">Update Contract Type</span>
                    <span class="page-title" id="contractTypeHeader" v-else>Add Contract Type</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackContractTypeList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content contract-type-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="ContractTypeForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="code">Code:</label>
                                        <input type="text" class="form-control" v-model="code" id="code" placeholder="Enter Code" name="code">
                                        <div class="field-error">{{code_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                        <div class="field-error">{{name_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="contract_type">Contract Type:</label>
                                        <v-select v-model="contract_type" name="contract_type" placeholder="Select Contract Type."
                                                    label="text"
                                                    @input="onContractChange($event)"
                                                    :options="contractTypesArr">
                                        </v-select>
                                        <div class="field-error">{{contract_type_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="billing_frequency_id">Billing Frequency:</label>
                                        <v-select v-model="billing_frequency_id" name="billing_frequency_id" placeholder="Select Billing Frequency."
                                                    label="text"
                                                    :options="billingFrequencyArr">
                                        </v-select>
                                        <div class="field-error">{{frequency_error_msg}}</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createContractTypeBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateContractType" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createContractTypeBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateContractType" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueContractTypeBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateContractType(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelContractTypeBtn" class="btn btn-tertiary" v-on:click.prevent="BackContractTypeList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>    
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';


export default {
  name: "ContractTypeCreate",
  
  metaInfo() {
      return {
          title: (this.$route.params.id > 0)? "Update Contract Type | " +process.env.COPYRIGHT_NAME : "Create Contract Type | " +process.env.COPYRIGHT_NAME
      }
  },
  mixins:[commonMixins,contractMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    code: "",
    name: "",
    frequency:"",
    section_id: "",
    sectionArr: [],
    loading:false,
    code_error_msg: "",
    name_error_msg: "",
    section_error_msg: "",
    frequency_error_msg:"",
    billing_frequency_id:null,
    contract_type:{text:"Lease",value:"lease"},
    contract_type_error_msg:""
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_contract_type') {
                        self.cantAccessPage = true;
                    }
                    
                }
            }

        },

  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
//        self.loadFieldData(['contractBillingFreq']);
        var path = window.location.pathname;
        var segments = path.split("/");
        
        if (segments[3]) {
            
            self.loadContractType();
        }else {

            if (self.contract_type.value == 'lease') {
                self.billingFrequencyArr = [{text: 'Monthly', value: 'monthly'}];
                self.billing_frequency_id = {text: 'Monthly', value: 'monthly'};

            }
        }
  },
  methods: {

    myChangeEvent(val){
        console.log(val);
    },
    mySelectEvent({id, text}){
        console.log({id, text})
    },
    onContractChange(event){
      var self = this;

      if(self.contract_type.value=='lease')
      {

          self.billingFrequencyArr=[{text:'Monthly',value:'monthly'}];
          self.billing_frequency_id={text:'Monthly',value:'monthly'};
      }
      if(self.contract_type.value=='rental' || self.contract_type.value=='maintenance' )
      {
          self.billing_frequency_id = "";
          self.billingFrequencyArr = [{text: 'Monthly', value: 'monthly'}, {text: 'Weekly', value: 'weekly'}];
      }
    },
    SectionRate(){

        var self = this;
        var arr = [];
        $.ajax({
            url: process.env.ROOT_API + "/contracttype/getsectionrate",
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                if (data.status == "success") {
                    var dataText = "";
                    var dataValue = "";
                    for(var i=0; i<data.content.length; i++) {
                        self.sectionArr = [{id: data.content[i].value, text: data.content[i].text}];
                        // dataValue = data.content[i].value;
                        // dataText = data.content[i].text;
                        // self.sectionArr.push(dataText);
                        
                    }
                    // alert(self.sectionArr);
                } 
            },
            error: function (jqXHR, exception) {
                self.generateStatusCodeMessage(jqXHR, true, 'get-contract-type-section-rate')
            }
        });
    },

    BackContractTypeList() {
      var self = this;
      self.$router.push("/contracttype/list");
    },

    CreateContractType(flag) {
        var self = this;
        var error = false;

        self.code = self.code.trim();
        self.name = self.name.trim();

        self.code_error_msg = "";
        self.name_error_msg = "";
        self.frequency_error_msg = "";
        self.contract_type_error_msg = "";

        if (!self.code || self.code == null || self.code == "") {
            self.code_error_msg = "Code required.";
            error = true;
        }

        if (!self.name || self.name == null || self.name == "") {
            self.name_error_msg = "Name required.";
            error = true;
        }

        if (!self.billing_frequency_id || self.billing_frequency_id == null || self.billing_frequency_id == "") {
            self.frequency_error_msg = "Billing frequency required.";
            error = true;
        }

        if (!self.contract_type || self.contract_type == null || self.contract_type == "") {
            self.contract_type_error_msg = "Contract Type required.";
            error = true;
        }

        if (!error) {

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createContractTypeBtn").val("Updating ...");
                $("#createContractTypeBtn").prop("disabled", true);
                $("#cancelContractTypeBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueContractTypeBtn").val("Saving ...");
                    $("#createContractTypeBtn").prop("disabled", true);
                    $("#createAndContinueContractTypeBtn").prop("disabled", true);
                    $("#cancelContractTypeBtn").prop("disabled",true);

                }else{

                    $("#createContractTypeBtn").val("Saving ...");
                    $("#createContractTypeBtn").prop("disabled", true);
                    $("#createAndContinueContractTypeBtn").prop("disabled", true);
                    $("#cancelContractTypeBtn").prop("disabled",true);
                }
               
            }
            
            $.ajax({
                url: process.env.ROOT_API + "/contracttype/create",
                type: "POST",
                data: {code: self.code,id: segments[3], name: self.name, billing_frequency_id: self.billing_frequency_id.value,contract_type : self.contract_type.value},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createContractTypeBtn").val("Update");
                        $("#createContractTypeBtn").prop("disabled", false);
                        $("#cancelContractTypeBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueContractTypeBtn").val("Save and Continue");
                            $("#createContractTypeBtn").prop("disabled", false);
                            $("#createAndContinueContractTypeBtn").prop("disabled", false);
                            $("#cancelContractTypeBtn").prop("disabled",false);

                        }else{

                            $("#createContractTypeBtn").val("Save");
                            $("#createContractTypeBtn").prop("disabled", false);
                            $("#createAndContinueContractTypeBtn").prop("disabled", false);
                            $("#cancelContractTypeBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            self.code = "";
                            self.name = "";
                            self.frequency = "";

                        }else{
                            self.$router.push("/contracttype/list");
                        }
                        
                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createContractTypeBtn").val("Update");
                        $("#createContractTypeBtn").prop("disabled", false);
                        $("#cancelContractTypeBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {
                            
                            $("#createAndContinueContractTypeBtn").val("Save and Continue");
                            $("#createContractTypeBtn").prop("disabled", false);
                            $("#createAndContinueContractTypeBtn").prop("disabled", false);
                            $("#cancelContractTypeBtn").prop("disabled",false);

                        }else{

                            $("#createContractTypeBtn").val("Save");
                            $("#createContractTypeBtn").prop("disabled", false);
                            $("#createAndContinueContractTypeBtn").prop("disabled", false);
                            $("#cancelContractTypeBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR, true, 'contract-type-create')
                }
            });
        }else{
            self.errorValidationFocus();
        }
    },

    loadContractType() {
        
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/contracttype/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.code = data.content.code;
                    self.name = data.content.name;
                    //self.frequency = data.content.frequency;
                    if(data.content.billing_frequency_id == null) {
                        self.billing_frequency_id = null;
                    }else{
                        self.billing_frequency_id = {value: data.content.billing_frequency_id, text: self.titleCase(data.content.cbfName + " (" + data.content.cbfCode +")")};
                    }
                    self.contract_type = {value: data.content.contract_type, text: self.titleCase(data.content.contract_type)};
                    self.billing_frequency_id = {value: data.content.billing_frequency, text: self.titleCase(data.content.billing_frequency)};
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR, false, 'get-contract-type-by-id')
            }
        });
    },
  }
};
</script>   


// WEBPACK FOOTER //
// src/components/ContractTypeCreate.vue